// extracted by mini-css-extract-plugin
export default {"facet-list_expander":"facet-list_expander_ZQrIlinw"};